import paths from 'Common/routes/paths';
import { PageType } from 'AppShell/appshell_types/routingTypes';

export const isClubMFWebPage = (pathName: string) => pathName.startsWith(paths.CLUB_MF_ROOT);
const isUpcomingCampaignPage = (pathName: string) => pathName.startsWith(paths.CLUB_MF_UPCOMING_CAMPAIGN_PAGE);
const isProductDetailPage = (pathName: string) => pathName.startsWith(paths.CLUB_MF_PRODUCT_DETAIL_PAGE);
const isClubServicePage = (pathName: string) => pathName.startsWith(paths.CLUB_MF_SERVICE_PAGE);

const routeMacherList: [(pathName: string) => boolean, PageType][] = [
    [isUpcomingCampaignPage, PageType.CLUB_UPCOMING_CAMPAIGN],
    [isProductDetailPage, PageType.CLUB_PDP],
    [isClubServicePage, PageType.CLUB_SERVICE_PAGE],
];

export const getClubPageType = (pathName: string): PageType => {
    const result = routeMacherList.find(([matcher]) => matcher(pathName));
    return result ? result[1] : PageType.EXTERNAL;
};
